import { createUniqueId } from './helper'
import REWARDS from '../constants/REWARDS'

const createRewardBase = (rewardString) => {
    const [identifier, details] = rewardString.split('_')
    const { name, type, category } = REWARDS[identifier]
    return ({
        ID: `reward_${createUniqueId()}`,
        source: rewardString,
        name,
        type,
        category,
        identifier,
        details,
    })
}

const getRewardData = rewardString => createRewardBase(rewardString)

export default {
    createRewardBase,
    getRewardData,
}
